import React from 'react';
import { IEventLight } from '../../Models';
import { ConditionalWrapper } from '../ConditionalWrapper';

interface IEventItemProps extends IEventLight {
    eventLink: string;
}

export function EventItem(content: IEventItemProps) {
    let dateTxt: JSX.Element;
    if (content.dateEndString == content.dateStartString) {
        dateTxt = <>{content.dateStartString}</>;
    } else {
        dateTxt = (
            <>
                {content.dateStartString}
                <i className="icon-point"></i>
                {content.dateEndString}
            </>
        );
    }

    return (
        <ConditionalWrapper
            condition={content.eventLink}
            wrapper={(children: React.ReactNode) => (
                <a
                    href={content.eventLink + '?reference=' + content.reference}
                    className="link-tile gtm-event"
                    title={content.title}
                >
                    {children}
                </a>
            )}
        >
            <article className="tile tile--news">
                <div className="header">
                    <div className="state date">{dateTxt}</div>
                    <h3 className="title">{content.title}</h3>
                </div>
                <p>{content.description}</p>
                {content.category && (
                    <div className="additional-text">{content.category}</div>
                )}
            </article>
        </ConditionalWrapper>
    );
}
